export function getPathName(path?: string) {
  if (!path) return '';

  const parts = path.split('/').filter(Boolean);

  return parts[parts.length - 1] || '';
}

export function buildChildPath(parentPath: string, name: string) {
  if (!parentPath || parentPath === '/') {
    return `/${name}`;
  }

  return `${parentPath}/${name}`;
}

export function getPathIdsFromUrl() {
  const value = new URL(window.location.href).searchParams.get('pathIds');

  if (!value) return [];

  return value
    .split(',')
    .map(item => item.trim())
    .filter(Boolean);
}

export function setPathIdsToUrl(ids: Array<number | string>) {
  const url = new URL(window.location.href);

  if (!ids.length) {
    url.searchParams.delete('pathIds');
  } else {
    url.searchParams.set('pathIds', ids.map(String).join(','));
  }

  window.history.replaceState(null, '', url.toString());
}

export function buildSegmentsFromPathIds(params: {
  ids: Array<number | string>;
  fullPath: string;
  myFileRootId: number | string | null;
}) {
  const names = params.fullPath.split('/').filter(Boolean);

  return names.map((name, index) => {
    const id = params.ids[index];
    const isMyFilePath =
      params.myFileRootId != null &&
      String(id) === String(params.myFileRootId);

    return {
      id,
      name,
      path: '/' + names.slice(0, index + 1).join('/'),
      is_private: isMyFilePath,
    };
  });
}